import supabaseClient from '@/api/supabaseClient.ts';
import { TripRepository } from '$/repositories/tripRepository/TripRepository.ts';

const tripRepository = new TripRepository(supabaseClient);
export default tripRepository;

